/* src/app/ship/ship-customs-docs/ship-customs-docs.component.scss */
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.fill-height,
.white-content-page,
.white-sheet-content {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  align-content: stretch;
}
.page-center,
.white-content-page .ups-content-block,
.white-content-page .ups-page-header,
.white-sheet-content {
  min-width: 21.5rem;
  max-width: 71.875rem;
  width: 100%;
  margin: 0 auto;
}
.white-sheet-content {
  background-color: white;
}
.white-sheet-content .ups-page-header {
  padding: 1.125rem 23px;
}
@media screen and (min-width: 48rem) {
  .white-sheet-content .ups-page-header {
    padding: 2.625rem 2rem;
  }
}
.white-content-page {
  background-color: white;
  min-height: 100%;
}
.white-content-page .ups-page-header {
  padding-bottom: 1em;
  min-width: auto;
}
.white-content-page .ups-content-block {
  padding: 0 2rem 2em;
}
.ship-customs-doc .form-section-header {
  margin-bottom: 0 !important;
}
.ship-customs-doc .help-icon {
  width: 15px;
  height: 15px;
  margin: 0 0.5em;
}
.ship-customs-doc .option-title {
  font-size: 0.75em;
}
.ship-customs-doc .invoice-uploader {
  padding-left: 1.75rem;
}
.ship-customs-doc .invoice-uploader .uploader-message,
.ship-customs-doc .invoice-uploader .file-type-message {
  font-size: 0.75em;
  color: #817b7b;
}
.ship-customs-doc .invoice-uploader .uploader-message a,
.ship-customs-doc .invoice-uploader .file-type-message a {
  color: #004791;
  text-decoration: underline;
  font-weight: 700;
}
.ship-customs-doc .invoice-uploader .uploader {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}
.ship-customs-doc .invoice-uploader .uploader label input[type=file] {
  height: 0;
  margin-left: -9999px;
}
.ship-customs-doc .invoice-uploader .uploader .error-message {
  color: #DF2901;
  font-size: 0.8em;
  padding: 0 0.5rem;
}
.ship-customs-doc .file-upload-chip {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 0.5rem 0 0.5rem 1.75rem;
}
.ship-customs-doc .file-upload-chip ::ng-deep .mat-mdc-chip:not(.mat-mdc-basic-chip) {
  border-radius: 3px;
  background-color: #f4f4f4;
}
.ship-customs-doc .file-upload-chip .remove-link {
  font-size: 0.75em;
  color: #817b7b;
  padding: 0 0.5rem;
  cursor: pointer;
}
.ship-customs-doc .file-upload-chip .remove-link:hover {
  text-decoration: none;
}
/*# sourceMappingURL=ship-customs-docs.component.css.map */
